<template>
  <div class="top-info flow">
    <BlogAuthorPreview :authors="authors" />
    <div class="top-info__date-time-section">
      <div class="top-info__date-time paragraph--s">
        {{ dateField }}
      </div>
      <BlogPostEstim />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { BlogAuthorStoryblok, Story } from '@/types'

import monthNames from '@/data/month_names.json'

interface Props {
  authors: Story<BlogAuthorStoryblok>[]
  date: Date | null
}
const props = defineProps<Props>()

const dateField = computed(() => {
  if (!props.date) {
    return ''
  }

  const monthName = monthNames[props.date.getMonth()]
  const dayNumber = props.date.getDate()
  const year = props.date.getFullYear()

  return `${monthName} ${dayNumber}, ${year}`
})
</script>

<style lang="scss" scoped>
.top-info {
  --space: 12px;

  display: flex;
  flex-direction: column;
  margin-bottom: 48px;

  @media (min-width: $breakpoint-md) {
    --space: 0px;

    flex-direction: row;
    align-items: center;
  }

  &__name {
    font-weight: 500;
    color: var(--navy-400);
    margin: 0 20px 0 12px;
  }

  &__date-time {
    color: var(--navy-600);
    margin-right: 20px;
  }

  &__date-time-section {
    display: flex;
    align-items: center;
  }

  &__picture-section {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    @media (min-width: $breakpoint-md) {
      margin-bottom: 0;
    }
  }

  &__picture {
    width: 40px;
    border-radius: 20px;

    &:not(:first-child) {
      position: relative;
      right: 10px;
      margin-right: -10px;
    }
  }
}
</style>
